import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import {
  postRemovePromoCode,
  togglePromoCodeInputVisibility
} from '../../state/Checkout.actions';

import DurationSelect from './DurationSelect';
import PricingList from './PricingList';
import Footer from './Footer';
import styles from './styles.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';

export class Summary extends React.Component {
  toggleShowPromoCodeInput = () => {
    this.props.handleTogglePromoCodeInputVisibility();
  };

  handlePostRemovePromoCode = () => {
    const { packageIds, handlePostRemovePromoCode } = this.props;

    const formData = {
      package_ids: packageIds
    };
    handlePostRemovePromoCode(formData);
  };

  render() {
    const {
      promotionApplied,
      isTrial,
      isTrialEligible,
      duration,
      promotionArgument,
      cartData,
      isPromoCodeInputVisible,
      promoCampaign
    } = this.props;

    return (
      <div className={styles.checkoutSummary}>
        <div className={`${styles.card} card`}>
          {promoCampaign ? (
            <h4 className={`${styles.inset} ${styles.promoHeader}`}>
              {I18n.t(`${I18nPrefix}.membership.${duration}`)}
            </h4>
          ) : (
            <>
              <div className={styles.inset}>
                <DurationSelect />
              </div>
            </>
          )}
          <PricingList />

          <div className={`${styles.inset} ${styles.summaryFooter}`}>
            <Footer
              showPromoCode={!promoCampaign}
              promotionApplied={promotionApplied}
              isTrial={isTrial}
              isTrialEligible={isTrialEligible}
              cartData={cartData}
              isPromoCodeInputVisible={isPromoCodeInputVisible}
              onToggleShowPromoCodeInput={this.toggleShowPromoCodeInput}
              handleRemovePromoCode={this.handlePostRemovePromoCode}
            />
          </div>

          <div className={`${styles.inset} ${styles.footnote}`}>
            {cartData.recurringAmount !== cartData.billedToday &&
              I18n.t(`${I18nPrefix}.price_after_discount_v2.${duration}`, {
                price: Cldr.formatCurrency(
                  cartData.recurringAmount,
                  cartData.currency
                ),
                count: promotionArgument
              })}{' '}
            {I18n.t(`${I18nPrefix}.cancel`)}
          </div>
        </div>
      </div>
    );
  }
}

Summary.defaultProps = {
  promotionArgument: 0,
  promotionApplied: false,
  isTrial: false,
  isPromoCodeInputVisible: false,
  promoCampaign: false
};

Summary.propTypes = {
  isTrial: PropTypes.bool,
  isTrialEligible: PropTypes.bool.isRequired,
  promotionApplied: PropTypes.bool,
  isPromoCodeInputVisible: PropTypes.bool,
  duration: PropTypes.string.isRequired,
  promotionArgument: PropTypes.number,
  cartData: PropTypes.shape({
    selectedPackages: PropTypes.arrayOf(PropTypes.object).isRequired,
    currency: PropTypes.string.isRequired,
    recurringAmount: PropTypes.number.isRequired,
    billedToday: PropTypes.number.isRequired
  }).isRequired,
  packageIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  handlePostRemovePromoCode: PropTypes.func.isRequired,
  handleTogglePromoCodeInputVisibility: PropTypes.func.isRequired,
  promoCampaign: PropTypes.bool
};

const mapStateToProps = (state) => ({
  checkoutSubmitting: state.checkout_submitting,
  promoCodeSubmitting: state.promo_code_submitting,
  promotionApplied: !!state.products.promotion.code,
  fullPromo: state.products.promotion.full,
  isTrial: state.isTrial,
  isTrialEligible: state.isTrialEligible,
  duration: state.duration,
  promotionArgument: state.products.promotion.argument,
  cartData: state.products[state.duration],
  packageIds: state.package_ids,
  yearlyPercentOff: state.yearly_percent_off,
  isPromoCodeInputVisible: state.promo_code_input_visibility,
  promoCampaign: state.promoCampaign
});

export default connect(
  mapStateToProps,
  {
    handlePostRemovePromoCode: postRemovePromoCode,
    handleTogglePromoCodeInputVisibility: togglePromoCodeInputVisibility
  }
)(Summary);
